/** 
 * js for the main index page 
 **/

/* do we have page visibility api and the page is not visible? */
/*var ptDelayedStartEasySlider = ((typeof document.hidden !== "undefined")
		&&(typeof document.addEventListener !== "undefined")
		&&(document.hidden)
);*/

$(document).ready(function() {

	/* Load this early, to remove flickr */
	/*$('#slider').easySlider({
		auto: !ptDelayedStartEasySlider,
		continuous: true,
		numeric: true,
		controlsShow: true,
		pause: 7000
	});

	if (ptDelayedStartEasySlider) {
		var ptHandleDocumentVisibilityChange;
		ptHandleDocumentVisibilityChange = function() {
			if (!document.hidden) {
				$('#slider').easySliderStart();
				document.removeEventListener("visibilitychange", ptHandleDocumentVisibilityChange, false);
			}
		};
		// do not start the slider, but start it one time once the page is visible
		document.addEventListener("visibilitychange", ptHandleDocumentVisibilityChange, false);
		console.log("window not visible, easySlider start delayed");
	}*/
	
	$('.fancybox').each(function(){
		$(this).data('thumb', $(this).attr('href'));
	});
	$('.fancybox').fancybox({
		'afterClose':function() {
				$('.header-container').show();
			},
			'beforeShow':function(instance, current) {
				
				instance.current.opts.caption = $(instance.current.opts.$orig[0]).attr('title');
			},
		  thumbs: {
		    autoStart: true, // Display thumbnails on opening
		    hideOnClose: true, // Hide thumbnail grid when closing animation starts
		    parentEl: ".fancybox-container", // Container is injected into this element
		    axis: "y" // Vertical (y) or horizontal (x) scrolling
		  }
	});
	
	$('.slide-showvideo, .slide-showvideo-button, .mobile-landing .video .play')
		.on('click', function() {
			//$('#slider').easySliderStop();
		})
		.fancybox({
			width       : 960, 
			height      : 540,
			openEffect  : 'none',
			closeEffect : 'none',
			afterLoad   : function() {
				pSendGAEvent('pt_video_click', {'pt_video_id': 'explanation'}, 'ptlanding.js', 'Video send event gone wrong');
		    },
			media : {
	      youtube : {
	        params : {
	          autoplay : 0
	        }
	      }
	    }
		});
	
	$('.fancybox').on('click', function() {
	   $('.header-container').hide();
	});

	$(".scrollTo").on('click', function(event){		
		event.preventDefault();
		$('html,body').animate({scrollTop:$(this.hash).offset().top}, 1000);
		window.location.hash=$(this).attr('href');
	});
   
	$('#tabs').tabs();
	
	$(".showhide").hide();
	$(".showmore").show();

	
	/* FAQ */
	$('.showmore').on('click', function(){
		$(this).next(".showhide").slideToggle();
	});
	
	/* features */
	$('#features .showmore').on('click', function(){
		$(this).remove();
		$(this).next(".showhide").slideToggle();
	});
	
	/* Customers */	
	$('#kunden .showmore').on('click', function(){
		$(this).remove();
		//document.getElementById("kunden").scrollIntoView(true);
	  $('html,body').animate({
	  	scrollTop: $('#kunden').offset().top-100
	  }, 500, "linear", function(){
	  	$('#client-logos-more').slideDown(2000);
	  });
	});
	
	if (window.location.href.indexOf('#video')>0) {
		// show the video by triggering a click on the first fancybox button - to trigger click-handlers registered for stopping easySlider
		$(".slide-showvideo-button").eq(0).trigger('click');
	}
	
	
});

var ptLandingCurrencyLoaded = function(){
	$('#averagecostpervisit').html(ptNumber.sprintNumber(ptShop.prices.roi.averagecostpervisit, 0, true));
	$('#averagesavingspermonth').html(ptNumber.sprintNumber(ptShop.prices.roi.averagesavingspermonth, 0, true));
};

jQuery(document).on('ptShopCurrencyLoaded',  ptLandingCurrencyLoaded );


$.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) {
       return null;
    }
    return decodeURI(results[1]) || 0;
}